module.exports = __webpack_public_path__ + "img/15_Skilled Communicator.801caf2d.svg";